import React, { useState, useEffect } from "react";
// import Feedback from "./Feedback";
import "./Floaticons.css";
import { useMsal } from "@azure/msal-react";
function Floaticons() {
  return (
    <>
      <div className="float-wrap">
        <div className="float-box box1">
          <p>
            <a href="mailto:atci.gendertechprgs@accenture.com">
              <img
                src="images/Home/Contact-us-new.png"
                alt="icons"
                className="float-icons"
              />
              Contact Us
            </a>
          </p>
        </div>
        {/* <Feedback /> */}
        {/* <div className="float-box box2">
          <p>
            <a href="#" target="_blank">
              <img
                src="images/Home/Yammer-new.png"
                alt="icons"
                className="float-icons"
              />
              Yammer Community
            </a>
          </p>
        </div> */}
      </div>
    </>
  );
}

export default Floaticons;
